export enum BloodPressureStatus{
    Hypertensive = 1,
    HypertensionStageTwo = 2,
    HypertensionStageOne = 3,
    Elevated = 4,
    Normal = 5,
    Low = 6
}